import 'init/1-polyfills';
import 'init/2-containerWeb';
import 'init/3-prelude';
import 'init/4-i18next';
import { webNavigationModule } from 'src/bootstrap/iocModules/webNavigationModule';
import { createReactContainerAndRunStore } from 'src/lib/createReactContainerAndRunStore';
import { localWorkspaceServiceModule } from 'src/services/WorkspaceService/localWorkspaceServiceModule';
import { container } from 'src/StaticContainer';
import { launchDarklyBrowserModule } from 'src/store/modules/launchDarklyBrowserModule';
import { localStoreModule } from 'src/store/modules/localStoreModule';

if (!window.reactContainer) {
    container.load(launchDarklyBrowserModule);
    window.reactContainer = createReactContainerAndRunStore(localStoreModule, localWorkspaceServiceModule, {
        additional: [webNavigationModule],
    });
}
